const Routes = {
    DASHBOARD: '/dashboard',
    LOGIN: '/api/auth/signin',
    LOGOUT: '/auth/signout',
    CALLBACK: '/api/auth/callback',
    PROFILE: '/dashboard/profile',
    MY_PACKAGE: '/dashboard/profile/my-package',
    // Tabbed profile routes via query params (parallel routes)
    MY_PACKAGE_GROUP_TRADING: '/dashboard/profile/my-package?tab=groupTrading',
    MY_PACKAGE_LIVE_TRADE: '/dashboard/profile/my-package?tab=liveTrade',
    MY_PACKAGE_BACKTESTING: '/dashboard/profile/my-package?tab=backtesting',
    MY_PACKAGE_SIGNAL: '/dashboard/profile/my-package?tab=signal',
    MY_WALLET: '/dashboard/profile/my-wallet',
    MY_WALLET_WALLET: '/dashboard/profile/my-wallet?tab=wallet',
    MY_WALLET_EXCHANGE: '/dashboard/profile/my-wallet?tab=exchange',
    MY_WALLET_BROKER: '/dashboard/profile/my-wallet?tab=broker',
    MY_PROFILE: '/dashboard/profile/my-profile',
    MY_PROFILE_GENERAL: '/dashboard/profile/my-profile?tab=general',
    MY_PROFILE_SECURITY: '/dashboard/profile/my-profile?tab=security',
    MY_NOTIFICATION: '/dashboard/profile/my-notification',
    MY_AFFILIATE: '/dashboard/profile/my-affiliate',
    EXCHANGE: '/dashboard/exchange-settings',
    NOTIFICATION: '/dashboard/notification',
    STRATEGIES: '/dashboard/strategies',
    NEW_STRATEGY: '/dashboard/strategies/new',
    MARKETPLACE: '/dashboard/marketplace',
    BOT_RESULT: '/dashboard/result/{1}',
    CHARTS: '/dashboard/charts',
    BACKTEST_BOTS: '/dashboard/bots/backtest',
    NEW_BACKTEST_BOTS: '/dashboard/bots/backtest/new',
    BOTS_LIST: '/dashboard/bots/list',
    BOT_HISTORY: '/dashboard/bots/history',
    TRADE_BOTS: '/dashboard/bots/trade',
    NEW_TRADE_BOTS: '/dashboard/bots/trade/new',
    OPEN_ORDERS: '/dashboard/live/open-orders',
    TRADE_HISTORY: '/dashboard/live/trade-history',
    VERIFY_YOUR_ACCOUNT_ERROR: '/error/verify-email',
    AUTH_ERROR: '/error/auth',
    VERIFY_LOGIN_REQUEST: '/error/verify-login-request',
} as const;

export default Routes;
